import React, { Component } from 'react'
import './PerfilMobiliarioSolicitudes.css'; 
import {postMtoCorrectivoActivo,getSolicitudesCorrectivosActivo,clearErrors} from '../../../redux/actions/mobiliarioactions';
import {getRepuestos} from '../../../redux/actions/dataactions';
import {getUsuariosAsistenciales} from '../../../redux/actions/useractions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { FaArrowLeft, FaPlus, FaCheckCircle, FaCheck } from "react-icons/fa";

import {
    DataGrid,
    GridToolbar,
    esES
  } from '@mui/x-data-grid';
import MyButton from '../../../utils/MyButton';


import {
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    MenuItem,
    Select,
    InputLabel,
    Button,
    FormHelperText,
    CircularProgress,
    Typography,
    Stack,
    IconButton,
    Tooltip,
    Box,
    Grid
  } from '@mui/material';
  import PhotoIcon from '@mui/icons-material/Photo';
  import AssignmentIcon from '@mui/icons-material/Assignment';


export class PerfilMobiliarioSolicitudes extends Component {
    constructor(){
        super();
        this.state={
            errors:{},
            open:false,
            openevidencia:false,
            idsolicitud:'',
            fechasolicitud:'',
            horasolicitud:'',
           
            fallareportada:'',
            obsolescencia:false,
            malaoperacion:false,
            malainst:false,
            accesorios:false,
            caida:false,
            desgaste:false,
            corto:false,
            sinfalla:false,
            paciente:false,
            desconocido:false,
            otro:'',
            descactividad:'',
            descfalla:'',
            observaciones:'',
            apto:'',
            retirado:'',
            repuestoId: '',
            repuestoId1: '',
            repuestoId2: '',
            nombrerepuesto:'',
            nombrerepuesto1:'',
            nombrerepuesto2:'',
            cantidad:0,
            cantidad1:0,
            cantidad2:0,
            costo:0,
            costo1:0,
            costo2:0,
            subtotal:0,
            subtotal1:0,
            subtotal2:0,
            totalrepuesto:0,
            horainicio:'',
            horafinal:'',
            firmarecibe:'',
            cargorecibe:'',
            fecha:'',
            fechafinal:'',
            solicitud:{},
            tiemporespuesta:'',
            tiemporespuestahora:'',
            imagenurl:'',
            
            // Nuevos estados para métodos de firma
            metodoRecepcion: 'manual', // método por defecto
            // Estados para firma digital
            firmaDigital: null,
            firmaGuardada: false,
            uploadingImage: false,
            nombreFirmante: '',
            cargoFirmante: '',
            // Estados para selección de usuario
            usuarioRecibe: '',
            // Estados para carga de imagen
            imagenFirma: null,
            nombreFirmaImagen: '',
            cargoFirmaImagen: '',
            aprobado: {}
        };
        this.canvasRef = React.createRef();
    };

    componentDidMount(){
        this.props.getSolicitudesCorrectivosActivo(this.props.mobiliarioId);
       
        // Agregar escucha de evento de redimensionamiento de ventana para el canvas
        window.addEventListener('resize', this.resizeCanvas);
    }

    componentDidUpdate(prevProps, prevState) {
        // Si se cambia el método de recepción a "firma", inicializar el canvas
        if (prevState.metodoRecepcion !== this.state.metodoRecepcion) {
            if (this.state.metodoRecepcion === "firma" && this.canvasRef.current) {
                this.initCanvas();
            } else if (this.state.metodoRecepcion === "usuario") {
                // Cargar usuarios asistenciales cuando se selecciona este método
                if (this.props.user && this.props.user.credentials && this.props.user.credentials.handle) {
                    this.props.getUsuariosAsistenciales(this.props.clienteId);
                }
            }
        }
    }

    componentWillUnmount() {
        // Limpiar eventos al desmontar el componente
        window.removeEventListener('resize', this.resizeCanvas);
    }

    static getDerivedStateFromProps(props, state) {
        const newState = {};
      
        if (props.UI.errors) {
          newState.errors = props.UI.errors;
        }
      
        if (props.UI.aprobado) {
          newState.aprobado = props.UI.aprobado;
        }
      
        return Object.keys(newState).length > 0 ? newState : null;
    }

    // Redimensionar canvas para adaptarse al contenedor
    resizeCanvas = () => {
        if (!this.canvasRef.current) return;
        
        const canvas = this.canvasRef.current;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const container = canvas.parentElement;
        
        canvas.width = container.clientWidth * ratio;
        canvas.height = 200 * ratio;
        canvas.style.width = `${container.clientWidth}px`;
        canvas.style.height = "200px";
        
        const ctx = canvas.getContext("2d");
        ctx.scale(ratio, ratio);
        
        // Configurar estilos de dibujo
        ctx.lineJoin = 'round';
        ctx.lineCap = 'round';
        ctx.lineWidth = 2;
        ctx.strokeStyle = 'black';
        
        // Rellenar con fondo blanco
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    }

    // Iniciar dibujo
    startDrawing = (e) => {
        const canvas = this.canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        this.isDrawing = true;
        this.lastX = e.clientX - rect.left;
        this.lastY = e.clientY - rect.top;
    }

    // Manejar inicio táctil
    startDrawingTouch = (e) => {
        e.preventDefault();
        if (e.touches.length !== 1) return;
        
        const touch = e.touches[0];
        const canvas = this.canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        
        this.isDrawing = true;
        this.lastX = touch.clientX - rect.left;
        this.lastY = touch.clientY - rect.top;
    }

    // Dibujar en el canvas
    draw = (e) => {
        if (!this.isDrawing) return;
        
        const canvas = this.canvasRef.current;
        const ctx = canvas.getContext('2d');
        const rect = canvas.getBoundingClientRect();
        
        const currentX = e.clientX - rect.left;
        const currentY = e.clientY - rect.top;
        
        ctx.beginPath();
        ctx.moveTo(this.lastX, this.lastY);
        ctx.lineTo(currentX, currentY);
        ctx.stroke();
        
        this.lastX = currentX;
        this.lastY = currentY;
    }

    // Manejar movimiento táctil
    drawTouch = (e) => {
        e.preventDefault();
        if (!this.isDrawing || e.touches.length !== 1) return;
        
        const touch = e.touches[0];
        const canvas = this.canvasRef.current;
        const ctx = canvas.getContext('2d');
        const rect = canvas.getBoundingClientRect();
        
        const currentX = touch.clientX - rect.left;
        const currentY = touch.clientY - rect.top;
        
        ctx.beginPath();
        ctx.moveTo(this.lastX, this.lastY);
        ctx.lineTo(currentX, currentY);
        ctx.stroke();
        
        this.lastX = currentX;
        this.lastY = currentY;
    }

    // Detener dibujo
    stopDrawing = () => {
        this.isDrawing = false;
    }

    // Limpiar firma digital
    clearSignature = () => {
        if (!this.canvasRef.current) return;
        
        const canvas = this.canvasRef.current;
        const ctx = canvas.getContext('2d');
        
        // Limpiar canvas
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        this.setState({ firmaDigital: null });
    }

    // Verificar si el canvas está vacío
    isCanvasEmpty = () => {
        if (!this.canvasRef.current) return true;
        
        const canvas = this.canvasRef.current;
        const ctx = canvas.getContext('2d');
        
        const pixelData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        
        // Comprobar si todos los datos de píxeles son blancos (255, 255, 255, 255)
        for (let i = 0; i < pixelData.length; i += 4) {
            // Comprobar valores RGB (omitir alfa)
            if (pixelData[i] !== 255 || pixelData[i + 1] !== 255 || pixelData[i + 2] !== 255) {
                return false; // Se encontró un píxel no blanco
            }
        }
        
        return true; // El canvas está vacío (todo blanco)
    }

    // Guardar firma digital
    saveSignature = () => {
        if (!this.canvasRef.current) return;
        
        if (!this.isCanvasEmpty()) {
            const signatureData = this.canvasRef.current.toDataURL('image/png');
            
            // Guardar firma y establecer firmaGuardada a true
            this.setState({ 
                firmaDigital: signatureData,
                firmaGuardada: true, // Indicador visual de que la firma se guardó
                errors: {
                    ...this.state.errors,
                    firmaDigital: null
                }
            });
            
            // Mostrar mensaje de confirmación que desaparece después de unos segundos
            setTimeout(() => {
                this.setState({ firmaGuardada: false });
            }, 3000);
        } else {
            // Mostrar error - firma vacía
            this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    firmaDigital: "Es necesario firmar antes de guardar"
                }
            }));
        }
    }

    // Manejar carga de imagen
    handleImageButtonClick = () => {
        // Crear un input de archivo temporal
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'image/*';
        
        // Configurar el manejador de eventos antes de activar el input
        fileInput.addEventListener('change', (event) => {
            const file = event.target.files[0];
            if (file) {
                this.setState({ uploadingImage: true });
                
                const reader = new FileReader();
                
                reader.onload = (e) => {
                    this.setState({ 
                        imagenFirma: e.target.result,
                        uploadingImage: false,
                        errors: {
                            ...this.state.errors,
                            imagenFirma: null
                        }
                    });
                };
                
                reader.onerror = () => {
                    this.setState({ 
                        uploadingImage: false,
                        errors: {
                            ...this.state.errors,
                            imagenFirma: "Error al cargar la imagen"
                        }
                    });
                };
                
                reader.readAsDataURL(file);
            }
        });
        
        // Simular clic en el input
        fileInput.click();
    }

    // Obtener información de usuario por ID desde props
    getUserInfo = (userId, field) => {
        const { usuariosAsistenciales } = this.props.user;
        
        if (!usuariosAsistenciales) return '';
        
        const user = usuariosAsistenciales.find(u => u.idUsuario === userId);
        
        // Si el campo es 'cargo' pero no existe, proporcionar un valor predeterminado
        if (field === 'cargo' && (!user || !user[field])) {
            return 'Asistencial';
        }
        
        return user ? user[field] : '';
    }

    // Manejar cambio de método
    handleMethodChange = (event) => {
        const method = event.target.value;
        this.setState({ metodoRecepcion: method });
        
        // Si se elige la selección de usuario, cargar la lista de usuarios asistenciales
        if (method === 'usuario') {
            this.props.getUsuariosAsistenciales(this.props.clienteId);
        }
    }

    // Inicializar el canvas para firma
    initCanvas = () => {
        if (!this.canvasRef.current) return;
        
        const canvas = this.canvasRef.current;
        const ctx = canvas.getContext('2d');
        
        // Configurar canvas
        this.resizeCanvas();
        
        // Limpiar el canvas
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        // Configurar estado de dibujo
        this.isDrawing = false;
        this.lastX = 0;
        this.lastY = 0;
        
        // Configurar eventos para dibujo
        canvas.addEventListener('mousedown', this.startDrawing);
        canvas.addEventListener('mousemove', this.draw);
        canvas.addEventListener('mouseup', this.stopDrawing);
        canvas.addEventListener('mouseout', this.stopDrawing);
        
        // Eventos táctiles
        canvas.addEventListener('touchstart', this.startDrawingTouch);
        canvas.addEventListener('touchmove', this.drawTouch);
        canvas.addEventListener('touchend', this.stopDrawing);
    }
    
    handleOpen = (rawdata) => {
        const rawdatastate = rawdata; 
        console.log(rawdata);
        console.log(rawdatastate);
       
        let fecharaw = new Date(rawdata.datecreation); 
        
        // Formatear la fecha a "YYYY-MM-DD"
        let fecha = fecharaw.toISOString().split('T')[0];
        
        // Formatear la hora (manteniendo el formato original)
        let hora = fecharaw.toLocaleTimeString();
        
        this.setState({
            open: true,
            aprobado:{},
            errors:{},
            solicitud: rawdatastate,
            solicitudid: rawdatastate.solicitudid,
            fechasolicitud: fecha,
            fallareportada: rawdatastate.fallareportada,
            horasolicitud: hora
        });
        
        // Cargar los repuestos al abrir el diálogo
        if (this.props.user && this.props.user.credentials) {
              const { credentials } = this.props.user;
              
              if (credentials.tipouser === "Tecnico") {
                  // Si es técnico, usar handleuser para obtener repuestos
                  console.log('Es Tecnico')
                  console.log('Handle User'+credentials.handleuser);
                  if (credentials.handleuser) {
                      this.props.getRepuestos(credentials.handleuser);
                  }
              } else if (credentials.tipouser === "Ingeniero") {
                console.log('Es Ingeniero')
                  // Si es ingeniero, usar handle para obtener repuestos
                  if (credentials.handle) {
                      this.props.getRepuestos(credentials.handle);
                  }
              }
          }
        
        console.log(this.state);
    };

    handleOpenEvidencia = (imagenurl) => {
        console.log('Imagen URL: ' + imagenurl);
        this.setState({ openevidencia: true, imagenurl: imagenurl });
    };
        
    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
        
        // Si el evento proviene de un select de repuesto
        if (event.target.name === 'repuestoId' || event.target.name === 'repuestoId1' || event.target.name === 'repuestoId2') {
            const repuestoSeleccionado = this.props.data.repuestos.find(
                repuesto => repuesto.repuestoId === event.target.value
            );
            
            if (repuestoSeleccionado) {
                let nombreField, costoField;
                
                if (event.target.name === 'repuestoId') {
                    nombreField = 'nombrerepuesto';
                    costoField = 'costo';
                } else if (event.target.name === 'repuestoId1') {
                    nombreField = 'nombrerepuesto1';
                    costoField = 'costo1';
                } else {
                    nombreField = 'nombrerepuesto2';
                    costoField = 'costo2';
                }
                
                this.setState({ 
                    [nombreField]: repuestoSeleccionado.nombre,
                    [costoField]: repuestoSeleccionado.valorunitario 
                });
            }
        }
    };

    handleClose = () => {
        if (this.state.aprobado && this.state.aprobado.mensaje) {
            console.log(this.state.aprobado);
            
            this.setState({ open: false, errors: {}, aprobado: {} });
            // Recargar la lista de solicitudes
            this.props.getSolicitudesCorrectivosActivo(this.props.mobiliarioId);
        } else {
            this.setState({ open: false, errors: {},aprobado:{} });
        }
    };

    handleCloseEvidencia = () => {
        this.setState({ openevidencia: false, errors: {}, imagenurl: '' });
    };

    handlePostMto = () => {
        // Determinar qué método de recepción usar y preparar los datos en consecuencia
        let receptorInfo = {};
        
        switch(this.state.metodoRecepcion) {
            case 'manual':
                receptorInfo = {
                    firmarecibe: this.state.firmarecibe,
                    cargorecibe: this.state.cargorecibe,
                    metodoRecepcion: 'manual'
                };
                break;
                
            case 'firma':
                // Obtener los datos de firma del canvas
                if (this.canvasRef.current && !this.isCanvasEmpty()) {
                  const signatureData = this.canvasRef.current.toDataURL('image/png');
                  
                  receptorInfo = {
                      nombreFirmante: this.state.nombreFirmante,
                      cargoFirmante: this.state.cargoFirmante,
                      imagenFirma: signatureData,
                      metodoRecepcion: 'firma'
                  };
                } else {
                    // Mostrar error si no hay firma
                    this.setState(prevState => ({
                        errors: {
                            ...prevState.errors,
                            firmaDigital: "Es necesario firmar antes de guardar"
                        }
                    }));
                    return; // Salir sin enviar
                }
                break;
                
            case 'usuario':
                if (this.state.usuarioRecibe) {
                    receptorInfo = {
                        usuarioRecibe: this.state.usuarioRecibe,
                        metodoRecepcion: 'usuario'
                    };
                } else {
                    // Mostrar error si no se seleccionó usuario
                    this.setState(prevState => ({
                        errors: {
                            ...prevState.errors,
                            usuarioRecibe: "Debe seleccionar un usuario"
                        }
                    }));
                    return; // Salir sin enviar
                }
                break;
                
            case 'imagen':
                if (this.state.imagenFirma) {
                    receptorInfo = {
                        nombreFirmaImagen: this.state.nombreFirmaImagen,
                        cargoFirmaImagen: this.state.cargoFirmaImagen,
                        imagenFirma: this.state.imagenFirma,
                        metodoRecepcion: 'imagen'
                    };
                } else {
                    // Mostrar error si no se cargó imagen
                    this.setState(prevState => ({
                        errors: {
                            ...prevState.errors,
                            imagenFirma: "Se requiere una imagen de firma"
                        }
                    }));
                    return; // Salir sin enviar
                }
                break;
                
            default:
                receptorInfo = {
                    firmarecibe: this.state.firmarecibe,
                    cargorecibe: this.state.cargorecibe,
                    metodoRecepcion: 'manual'
                };
        }
        
        // Preparar el objeto completo de mantenimiento correctivo
        const newMtoCorrectivo = {
            fechasolicitud: this.state.fechasolicitud,
            horasolicitud: this.state.horasolicitud,
            
            fallareportada: this.state.fallareportada,
            obsolescencia: this.state.obsolescencia,
            malaoperacion: this.state.malaoperacion,
            malainst: this.state.malainst,
            accesorios: this.state.accesorios,
            caida: this.state.caida,
            desgaste: this.state.desgaste,
            corto: this.state.corto,
            sinfalla: this.state.sinfalla,
            paciente: this.state.paciente,
            desconocido: this.state.desconocido,
            otro: this.state.otro,
            descactividad: this.state.descactividad,
            descfalla: this.state.descfalla,
            apto: this.state.apto,
            retirado: this.state.retirado,
            repuestoId: this.state.repuestoId,
            repuestoId1: this.state.repuestoId1,
            repuestoId2: this.state.repuestoId2,
            nombrerepuesto: this.state.nombrerepuesto,
            nombrerepuesto1: this.state.nombrerepuesto1,
            nombrerepuesto2: this.state.nombrerepuesto2,
            cantidad: this.state.cantidad,
            cantidad1: this.state.cantidad1,
            cantidad2: this.state.cantidad2,
            costo: this.state.costo,
            costo1: this.state.costo1,
            costo2: this.state.costo2,
            subtotal: this.state.subtotal,
            subtotal1: this.state.subtotal1,
            subtotal2: this.state.subtotal2, 
            totalrepuesto: this.state.totalrepuesto,
            observaciones: this.state.observaciones,
            horainicio: this.state.horainicio,
            horafinal: this.state.horafinal,
            firmarecibe: this.state.firmarecibe,
            cargorecibe: this.state.cargorecibe,
            fecha: this.state.fecha,
            fechafinal: this.state.fechafinal,
            solicitud: this.state.solicitud,
            ...receptorInfo  // Incluir la información del método de recepción
        };
     
        let segundosatiempo = (s) => {
            const addZ = (n) => {
                return (n < 10 ? '0' : '') + n;
            }
            var ms = s % 1000;
            s = (s - ms) / 1000;
            var secs = s % 60;
            s = (s - secs) / 60;
            var mins = s % 60;
            var hrs = (s - mins) / 60;
            return addZ(hrs) + ':' + addZ(mins) + ':' + addZ(secs) + '.' + addZ(ms);
        }

        // Cálculo del tiempo de respuesta
        const fechaHoraSolicitud = new Date(`${newMtoCorrectivo.fechasolicitud}T${newMtoCorrectivo.horasolicitud}`);
        const fechaHoraInicio = new Date(`${newMtoCorrectivo.fecha}T${newMtoCorrectivo.horainicio}`);
        const tiempoRespuesta = fechaHoraInicio.getTime() - fechaHoraSolicitud.getTime();
        const tiempoRespuestaFormateado = segundosatiempo(tiempoRespuesta);
        
        // Cálculo del tiempo de reparación
        const fechaHoraFinal = new Date(`${newMtoCorrectivo.fechafinal}T${newMtoCorrectivo.horafinal}`);
        const tiempoReparacion = fechaHoraFinal.getTime() - fechaHoraInicio.getTime();
        const tiempoReparacionFormateado = segundosatiempo(tiempoReparacion);
        
        // Añadir los nuevos campos al objeto newMtoCorrectivo
        newMtoCorrectivo.tiemporespuesta = tiempoRespuesta;
        newMtoCorrectivo.tiemporespuestahora = tiempoRespuestaFormateado;
        newMtoCorrectivo.tiemporeparacion = tiempoReparacion;
        newMtoCorrectivo.tiemporeparacionformateado = tiempoReparacionFormateado;
        
        console.log(newMtoCorrectivo);
        console.log(newMtoCorrectivo.solicitud.mobiliarioid);
        console.log(newMtoCorrectivo.solicitud.idprestador);
        
       this.props.postMtoCorrectivoActivo(
            newMtoCorrectivo, 
            this.props.mobiliarioId, 
            this.props.clienteId, 
            this.state.solicitudid
        );
    }

  render() {
    const {  repuestos } = this.props.data; 
    const {solicitudescorrmobiliario,loadingsolcorr}=this.props.dataMob;
    const {errors}=this.state;
    const { UI:{loading}}=this.props; 
  

    this.state.subtotal=this.state.cantidad*this.state.costo;
    this.state.subtotal1=this.state.cantidad1*this.state.costo1;
    this.state.subtotal2=this.state.cantidad2*this.state.costo2;
    this.state.totalrepuesto=this.state.subtotal+this.state.subtotal1+this.state.subtotal2;
      // Opciones de repuestos para los selects
      const repuestosOptions = repuestos && repuestos.length > 0 ? (
        repuestos.map(repuesto => (
            <MenuItem key={repuesto.repuestoId} value={repuesto.repuestoId}>
                {repuesto.nombre}
            </MenuItem>
        ))
    ) : (
        <MenuItem value=""><em>No hay repuestos disponibles</em></MenuItem>
    );
       
        
          const columns = [
            {
                field: 'acciones',
                headerName: 'Acciones',
                flex:1, minwidth:120,
                sortable: false,
                filterable: false,
                disableColumnMenu: true,
                renderCell: (params) => (
                  <Stack direction="row" spacing={1}>
                    <Tooltip title="Hacer Mantenimiento Correctivo">
                      <span>
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => this.handleOpen(params.row)}
                          disabled={params.row.estado === 'Atendida'}
                        >
                          <FaPlus size={16} />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Ver evidencia cargada">
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => this.handleOpenEvidencia(params.row.imageUrl)}
                      >
                        <PhotoIcon />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                ),
              },
            { field: 'datecreation', headerName: 'Fecha', flex:1, minwidth:120},
            { field: 'nombresolicita', headerName: 'Solicitante', flex:1, minwidth:120 },
            { field: 'fallareportada', headerName: 'Falla',flex:1, minwidth:140, },
            { field: 'estado', headerName: 'Estado', flex:1, minwidth:120},
            
          ];


          const mapeoSolicitudesCorrectivos = !loadingsolcorr ? (
            <div style={{ width: '100%' }}>
              <DataGrid
                rows={solicitudescorrmobiliario || []}
                columns={columns}
                getRowId={(row) => row.solicitudid}
                pageSize={5}
                rowsPerPageOptions={[5, 10, 20]}
                autoHeight
                
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                sx={{
                    borderRadius: 2,
                    backgroundColor: '#fff',
                    boxShadow: 3,
                    '& .MuiDataGrid-cell': {
                      fontSize: 14,
                    },
                    '& .MuiDataGrid-columnHeaders': {
                      backgroundColor: '#0588FB',
                      color: '#fff',
                      fontWeight: 'bold',
                      fontSize: 15,
                    },
                    '& .MuiDataGrid-row:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                  }}
              />
            </div>
          ) : (
            <div className="div_cargando">
              <CircularProgress size={50} color="primary" className="login-progress" />
            </div>
          );
    return (
      <div className="listamtoprog-container">
              
            <div className="listamtoprog-table">
            {mapeoSolicitudesCorrectivos}
            </div>


            <Dialog
             open={this.state.open}
             onClose={this.handleClose}
             fullWidth
             maxWidth="sm"
            >
            {this.state.aprobado && this.state.aprobado.mensaje ? (
                <div className='div-aprobado'>
                                  <div className='div-icono-aprobado'>
                                    <FaCheck color="#ffffff" className='icono-aprobado'/>
                                  </div>
                                  <h2 className='text-aprobado'>Reporte Cargado Exitosamente</h2>
                              </div>
                ) : (<div>
                    <DialogTitle>Realizar Reporte de Mantenimiento Correctivo</DialogTitle>
                    <DialogContent dividers> 
                        
                        <form>
                        <Grid container spacing={2}>
          <Grid item xs={12}>
             <Typography sx={{
                  color: '#0468BF',
                  fontSize: '18px',
                  fontWeight: 400,
                  ml: 1,
                }}>Información Solicitud</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Fecha de Solicitud"
              name="fechasolicitud"
              value={this.state.fechasolicitud}
              fullWidth
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Hora de Solicitud"
              name="horasolicitud"
              value={this.state.horasolicitud}
              fullWidth
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              multiline
              rows={4}
              label="Falla Reportada"
              name="fallareportada"
              value={this.state.fallareportada}
              fullWidth
              InputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid item xs={12}>
             <Typography sx={{
                  color: '#0468BF',
                  fontSize: '18px',
                  fontWeight: 400,
                  ml: 1,
                }}>Causas de la Falla</Typography>
          </Grid>

          {[
            ['obsolescencia', 'Obsolescencia'],
            ['malaoperacion', 'Mala Operación'],
            ['malainst', 'Mala Instalación'],
            ['desgaste', 'Desgaste'],
            ['caida', 'Caída'],
            ['corto', 'Corto Circuito'],
            ['accesorios', 'Accesorios'],
            ['paciente', 'Paciente'],
            ['sinfalla', 'Sin Falla'],
            ['desconocido', 'Desconocido']
          ].map(([field, label]) => (
            <Grid item xs={12} sm={6} key={field}>
              <FormControl fullWidth error={Boolean(this.state.errors[field])}>
                <InputLabel>{label}</InputLabel>
                <Select
                  name={field}
                  value={this.state[field]}
                  onChange={this.handleChange}
                  label={label}
                >
                  <MenuItem value=""><em>Seleccione</em></MenuItem>
                  <MenuItem value={true}>Sí</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </Select>
                <FormHelperText>{this.state.errors[field]}</FormHelperText>
              </FormControl>
            </Grid>
          ))}



          <Grid item xs={12}>
            <TextField
              label="Otro"
              name="otro"
              value={this.state.otro}
              onChange={this.handleChange}
              fullWidth
              helperText={this.state.errors.otro}
              error={Boolean(this.state.errors.otro)}
            />
          </Grid>



          <Grid item xs={12}>
  <Typography variant="h6">Descripción de la Actividad</Typography>
</Grid>
<Grid item xs={12}>
  <TextField
    label="Descripción de la Falla Encontrada"
    name="descfalla"
    value={this.state.descfalla}
    onChange={this.handleChange}
    fullWidth
    multiline
    rows={4}
    helperText={this.state.errors.descfalla}
    error={Boolean(this.state.errors.descfalla)}
  />
</Grid>
<Grid item xs={12}>
  <TextField
    label="Descripción de la Actividad Realizada"
    name="descactividad"
    value={this.state.descactividad}
    onChange={this.handleChange}
    fullWidth
    multiline
    rows={4}
    helperText={this.state.errors.descactividad}
    error={Boolean(this.state.errors.descactividad)}
  />
</Grid>
<Grid item xs={12}>
  <TextField
    label="Observaciones"
    name="observaciones"
    value={this.state.observaciones}
    onChange={this.handleChange}
    fullWidth
    multiline
    rows={4}
    helperText={this.state.errors.observaciones}
    error={Boolean(this.state.errors.observaciones)}
  />
</Grid>

<Grid item xs={12}>
  <Typography variant="h6">Repuestos Utilizados</Typography>
</Grid>


{[0, 1, 2].map((i) => (
  <React.Fragment key={i}>
    <Grid item xs={12} sm={6} md={3}>
      <FormControl fullWidth error={Boolean(this.state.errors[`repuestoId${i || ''}`])}>
        <InputLabel>Repuesto</InputLabel>
        <Select
          name={`repuestoId${i || ''}`}
          value={this.state[`repuestoId${i || ''}`]}
          onChange={this.handleChange}
          label="Repuesto"
        >
          <MenuItem value=""><em>Seleccione un repuesto</em></MenuItem>
          {this.props.data.repuestos.map((r) => (
            <MenuItem key={r.repuestoId} value={r.repuestoId}>{r.nombre}</MenuItem>
          ))}
        </Select>
        <FormHelperText>{this.state.errors[`repuestoId${i || ''}`]}</FormHelperText>
      </FormControl>
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        label="Cantidad"
        
        inputProps={{ min: 0 }}
        name={`cantidad${i || ''}`}
        value={this.state[`cantidad${i || ''}`]}
        onChange={this.handleChange}
        type="number"
        fullWidth
        helperText={this.state.errors[`cantidad${i || ''}`]}
        error={Boolean(this.state.errors[`cantidad${i || ''}`])}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        label="Costo"
        name={`costo${i || ''}`}
        value={this.state[`costo${i || ''}`]}
        onChange={this.handleChange}
        fullWidth
        InputProps={{ readOnly: true }}
        helperText={this.state.errors[`costo${i || ''}`]}
        error={Boolean(this.state.errors[`costo${i || ''}`])}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        label="Subtotal"
        name={`subtotal${i || ''}`}
        value={this.state[`subtotal${i || ''}`]}
        onChange={this.handleChange}
        fullWidth
        InputProps={{ readOnly: true }}
        helperText={this.state.errors[`subtotal${i || ''}`]}
        error={Boolean(this.state.errors[`subtotal${i || ''}`])}
      />
    </Grid>
  </React.Fragment>
))}

<Grid item xs={12}>
  <Typography variant="body1"><strong>Total:</strong> ${this.state.totalrepuesto}</Typography>
</Grid>

<Grid item xs={12}>
  <Typography variant="h6">Estado del Equipo</Typography>
</Grid>
<Grid item xs={12} sm={6}>
  <FormControl fullWidth error={Boolean(this.state.errors.apto)}>
    <InputLabel>¿Equipo Apto para su Uso?</InputLabel>
    <Select
      name="apto"
      value={this.state.apto}
      onChange={this.handleChange}
      label="¿Equipo Apto para su Uso?"
    >
      <MenuItem value=""><em>Seleccione</em></MenuItem>
      <MenuItem value={true}>Sí</MenuItem>
      <MenuItem value={false}>No</MenuItem>
    </Select>
    <FormHelperText>{this.state.errors.apto}</FormHelperText>
  </FormControl>
</Grid>
<Grid item xs={12} sm={6}>
  <FormControl fullWidth error={Boolean(this.state.errors.retirado)}>
    <InputLabel>¿El Equipo debe ser Retirado?</InputLabel>
    <Select
      name="retirado"
      value={this.state.retirado}
      onChange={this.handleChange}
      label="¿El Equipo debe ser Retirado?"
    >
      <MenuItem value=""><em>Seleccione</em></MenuItem>
      <MenuItem value={true}>Sí</MenuItem>
      <MenuItem value={false}>No</MenuItem>
    </Select>
    <FormHelperText>{this.state.errors.retirado}</FormHelperText>
  </FormControl>
</Grid>


<Grid item xs={12}>
  <Typography variant="h6">Fecha y Hora</Typography>
</Grid>
<Grid item xs={12} sm={6}>
  <TextField
    label="Fecha Inicio"
    name="fecha"
    type="date"
    value={this.state.fecha}
    onChange={this.handleChange}
    fullWidth
    InputLabelProps={{ shrink: true }}
    inputProps={{ min: '2019-01-01', max: '2030-01-01' }}
    helperText={this.state.errors.fecha}
    error={Boolean(this.state.errors.fecha)}
  />
</Grid>
<Grid item xs={12} sm={6}>
  <TextField
    label="Fecha Final"
    name="fechafinal"
    type="date"
    value={this.state.fechafinal}
    onChange={this.handleChange}
    fullWidth
    InputLabelProps={{ shrink: true }}
    inputProps={{ min: '2019-01-01', max: '2030-01-01' }}
    helperText={this.state.errors.fechafinal}
    error={Boolean(this.state.errors.fechafinal)}
  />
</Grid>
<Grid item xs={12} sm={6}>
  <TextField
    label="Hora de Inicio"
    name="horainicio"
    type="time"
    value={this.state.horainicio}
    onChange={this.handleChange}
    fullWidth
    InputLabelProps={{ shrink: true }}
    helperText={this.state.errors.horainicio}
    error={Boolean(this.state.errors.horainicio)}
  />
</Grid>
<Grid item xs={12} sm={6}>
  <TextField
    label="Hora Final"
    name="horafinal"
    type="time"
    value={this.state.horafinal}
    onChange={this.handleChange}
    fullWidth
    InputLabelProps={{ shrink: true }}
    helperText={this.state.errors.horafinal}
    error={Boolean(this.state.errors.horafinal)}
  />
</Grid>

<Grid item xs={12}>
  <Typography variant="h6">Personal que recibe la actividad</Typography>
</Grid>
<Grid item xs={12}>
  <FormControl fullWidth error={Boolean(this.state.errors.metodoRecepcion)}>
    <InputLabel>Método de recepción</InputLabel>
    <Select
      name="metodoRecepcion"
      value={this.state.metodoRecepcion || "manual"}
      onChange={(e) => {
        this.handleChange(e);
        this.handleMethodChange(e);
      }}
      label="Método de recepción"
    >
      <MenuItem value="manual">Ingreso manual</MenuItem>
      <MenuItem value="firma">Firma digital</MenuItem>
      <MenuItem value="usuario">Seleccionar usuario</MenuItem>
      <MenuItem value="imagen">Cargar imagen</MenuItem>
    </Select>
    <FormHelperText>{this.state.errors.metodoRecepcion}</FormHelperText>
  </FormControl>
</Grid>

{this.state.metodoRecepcion === 'manual' && (
  <>
    <Grid item xs={12} sm={6}>
      <TextField
        label="Nombre de Quien Recibe"
        name="firmarecibe"
        value={this.state.firmarecibe}
        onChange={this.handleChange}
        fullWidth
        helperText={this.state.errors.firmarecibe}
        error={Boolean(this.state.errors.firmarecibe)}
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <TextField
        label="Cargo de Quien Recibe"
        name="cargorecibe"
        value={this.state.cargorecibe}
        onChange={this.handleChange}
        fullWidth
        helperText={this.state.errors.cargorecibe}
        error={Boolean(this.state.errors.cargorecibe)}
      />
    </Grid>
  </>
)}

{this.state.metodoRecepcion === 'firma' && (
  <>
    <Grid item xs={12}>
      <Typography variant="body1">Firma Digital</Typography>
    </Grid>
    <Grid item xs={12}>
      <canvas
        ref={this.canvasRef}
        id="firma-digital-canvas"
        style={{ width: '100%', height: 200, border: '1px solid #ccc' }}
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <Button
        fullWidth
        variant="outlined"
        onClick={this.clearSignature}
      >
        Limpiar firma
      </Button>
    </Grid>
    <Grid item xs={12} sm={6}>
      <Button
        fullWidth
        variant="contained"
        onClick={this.saveSignature}
      >
        Guardar firma
      </Button>
    </Grid>
       {this.state.firmaGuardada && (
                <Grid item xs={12}>
                  <Typography color="success.main" align="center">
                    Firma guardada correctamente
                  </Typography>
                </Grid>
              )}
    <Grid item xs={12} sm={6}>
      <TextField
        label="Nombre del firmante"
        name="nombreFirmante"
        value={this.state.nombreFirmante}
        onChange={this.handleChange}
        fullWidth
        helperText={this.state.errors.nombreFirmante}
        error={Boolean(this.state.errors.nombreFirmante)}
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <TextField
        label="Cargo del firmante"
        name="cargoFirmante"
        value={this.state.cargoFirmante}
        onChange={this.handleChange}
        fullWidth
        helperText={this.state.errors.cargoFirmante}
        error={Boolean(this.state.errors.cargoFirmante)}
      />
    </Grid>
  </>
)}


{this.state.metodoRecepcion === 'usuario' && (
  <>
    <Grid item xs={12} >
      <FormControl fullWidth error={Boolean(this.state.errors.usuarioRecibe)}>
        <InputLabel>Usuario que recibe</InputLabel>
        <Select
          name="usuarioRecibe"
          value={this.state.usuarioRecibe || ''}
          onChange={this.handleChange}
          label="Usuario que recibe"
        >
          <MenuItem value="">
            <em>Seleccione un usuario</em>
          </MenuItem>
          {this.props.user.usuariosAsistenciales?.map(user => (
            <MenuItem key={user.idUsuario} value={user.idUsuario}>
              {user.nombre} {user.cargo ? `- ${user.cargo}` : ''}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{this.state.errors.usuarioRecibe}</FormHelperText>
      </FormControl>
    </Grid>
      {this.state.usuarioRecibe && (
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ mt: 2 }}>
                    <strong>Nombre:</strong> {this.getUserInfo(this.state.usuarioRecibe, 'nombre')}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Cargo:</strong> {this.getUserInfo(this.state.usuarioRecibe, 'cargo')}
                  </Typography>
                </Grid>
              )}
  </>
)}

{this.state.metodoRecepcion === 'imagen' && (
  <>
    <Grid item xs={12}>
      <Button
        variant="contained"
        onClick={this.handleImageButtonClick}
        disabled={this.state.uploadingImage}
        fullWidth
      >
        {this.state.uploadingImage ? 'Procesando...' : 'Cargar imagen de firma'}
      </Button>
    </Grid>

    {this.state.imagenFirma && (
      <Grid item xs={12}>
        <Box mt={2} display="flex" justifyContent="center">
          <img
            src={this.state.imagenFirma}
            alt="Vista previa de firma"
            style={{ maxWidth: '100%', maxHeight: '200px', border: '1px solid #ccc', borderRadius: 4 }}
          />
        </Box>
      </Grid>
    )}

    <Grid item xs={12} sm={6}>
      <TextField
        label="Nombre del firmante"
        name="nombreFirmaImagen"
        value={this.state.nombreFirmaImagen}
        onChange={this.handleChange}
        fullWidth
        helperText={this.state.errors.nombreFirmaImagen}
        error={Boolean(this.state.errors.nombreFirmaImagen)}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        label="Cargo del firmante"
        name="cargoFirmaImagen"
        value={this.state.cargoFirmaImagen}
        onChange={this.handleChange}
        fullWidth
        helperText={this.state.errors.cargoFirmaImagen}
        error={Boolean(this.state.errors.cargoFirmaImagen)}
      />
    </Grid>
  </>
)}
        </Grid>


        

                            


                        </form>  
                    </DialogContent>
                </div>)}

                <DialogActions>
                    <MyButton tip="Cerrar" onClick={this.handleClose}>
                        <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
                    </MyButton>
                    {loading ? (
                        <CircularProgress size={30} color="primary" className="login-progress" />
                    ) : (
                        this.state.aprobado && this.state.aprobado.mensaje ? (
                            <MyButton tip="Continuar" onClick={this.handleClose}>
                                <FaCheckCircle color="#20B90C" className="icon-formulario" />
                            </MyButton>
                        ) : (
                            <MyButton tip="Realizar Mantenimiento" onClick={this.handlePostMto}>
                                <FaPlus color="#03178C" className="icon-formulario" />
                            </MyButton>
                        )
                    )}
                </DialogActions>
            </Dialog>

            <Dialog
             open={this.state.openevidencia}
             onClose={this.handleCloseEvidencia}
             fullWidth
            maxWidth="sm"
            >
            <DialogTitle>Evidencia de la Solicitud</DialogTitle>
         
            <DialogContent>
            <div className='div-image-carga'>
            {this.state.imagenurl?(
              <img src={this.state.imagenurl} alt="Selected" style={{ maxWidth: '100%', maxHeight: '400px' }} />
            ):(
              <p>No hay Evidencia para Mostrar</p>
            )

            }
           
            </div>
            </DialogContent>

            <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleCloseEvidencia}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
             </MyButton>
           
           </DialogActions>

            </Dialog>
    
    
        </div>
            
    )
  }
}

PerfilMobiliarioSolicitudes.propTypes = {
  getSolicitudesCorrectivosActivo: PropTypes.func.isRequired,
  getRepuestos: PropTypes.func.isRequired,
  getUsuariosAsistenciales: PropTypes.func.isRequired,
  postMtoCorrectivoActivo: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  dataMob:PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  mobiliarioId: PropTypes.string.isRequired,
  clienteId: PropTypes.string.isRequired
};

const mapActionsToProps = {
  getSolicitudesCorrectivosActivo,
  getRepuestos,
  getUsuariosAsistenciales,
  clearErrors,
  postMtoCorrectivoActivo
};

const mapStateToProps = (state) => ({
  user: state.user,
  data: state.data,
  dataMob:state.dataMob,
  UI: state.UI
});

export default connect(mapStateToProps, mapActionsToProps)(PerfilMobiliarioSolicitudes);

